export class TableContextEdit {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "editedBy",
            "baseName": "editedBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "editedAt",
            "baseName": "editedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextEdit.attributeTypeMap;
    }
    constructor() {
    }
}
